import { defineComponent as _defineComponent } from 'vue';
import { withModifiers as _withModifiers, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, createCommentVNode as _createCommentVNode } from "vue";
var _hoisted_1 = {
    key: 0,
    class: "fileupload_modal"
};
var _hoisted_2 = { class: "defalut_popup" };
var _hoisted_3 = { class: "popup_content d-flex flex-column align-items-center p-[1.875rem]" };
var _hoisted_4 = { class: "popup_title text-center" };
var _hoisted_5 = { class: "popup_desc text-center" };
var _hoisted_6 = { class: "file_uploader uploader" };
var _hoisted_7 = { class: "popup_btns d-flex align-items-center" };
var _hoisted_8 = { class: "popup_btn" };
var _hoisted_9 = { class: "popup_btn" };
import { ref } from 'vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'FileUploadModal',
    props: {
        locales: {},
        title: { default: '타이틀' }
    },
    emits: ['save'],
    setup: function (__props, _a) {
        var __expose = _a.expose, __emit = _a.emit;
        var emit = __emit;
        var files = ref([]);
        var props = __props;
        var save = function () {
            emit('save', files.value);
            closePopup();
        };
        var visiblePopup = ref(false);
        var showPopup = function () {
            visiblePopup.value = true;
            var scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
            document.body.style.overflow = 'hidden';
            document.body.style.paddingRight = "".concat(scrollbarWidth, "px");
        };
        var closePopup = function () {
            visiblePopup.value = false;
            document.body.style.overflow = '';
            document.body.style.paddingRight = '';
        };
        function onFilesChanged(changedFiles) {
            files.value = changedFiles;
        }
        __expose({ showPopup: showPopup, closePopup: closePopup });
        return function (_ctx, _cache) {
            var _component_file_upload_component = _resolveComponent("file-upload-component");
            return (visiblePopup.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                    _createElementVNode("div", {
                        class: "backdrop",
                        onClick: _withModifiers(closePopup, ["self"])
                    }),
                    _createElementVNode("div", _hoisted_2, [
                        _createElementVNode("div", _hoisted_3, [
                            _createElementVNode("div", { class: "x_btn d-flex justify-content-end" }, [
                                _createElementVNode("button", {
                                    type: "button",
                                    onClick: closePopup
                                }, _cache[0] || (_cache[0] = [
                                    _createElementVNode("svg", {
                                        width: "17",
                                        height: "17",
                                        viewBox: "0 0 17 17",
                                        fill: "none"
                                    }, [
                                        _createElementVNode("path", {
                                            d: "M16 1L1 16M1 1L16 16",
                                            stroke: "#333333",
                                            "stroke-width": "2",
                                            "stroke-linecap": "round",
                                            "stroke-linejoin": "round"
                                        })
                                    ], -1)
                                ]))
                            ]),
                            _createElementVNode("p", _hoisted_4, _toDisplayString(_ctx.locales.common_fileupload), 1),
                            _createElementVNode("span", _hoisted_5, _toDisplayString(props.title), 1),
                            _createElementVNode("div", _hoisted_6, [
                                _createVNode(_component_file_upload_component, {
                                    "max-files": 10,
                                    files: files.value,
                                    locales: _ctx.locales,
                                    url: "/company/upload/file",
                                    "err-text": _ctx.locales.err_cv_filequantity_attack,
                                    "confirm-text": "확인",
                                    onChanged: onFilesChanged,
                                    "file-type": "partnership"
                                }, null, 8, ["files", "locales", "err-text"])
                            ]),
                            _createElementVNode("div", _hoisted_7, [
                                _createElementVNode("div", _hoisted_8, [
                                    _createElementVNode("button", {
                                        type: "button",
                                        onClick: closePopup,
                                        class: "white_btn"
                                    }, _toDisplayString(_ctx.locales.common_cancel), 1)
                                ]),
                                _createElementVNode("div", _hoisted_9, [
                                    _createElementVNode("button", {
                                        type: "button",
                                        class: "blue_btn",
                                        onClick: save
                                    }, _toDisplayString(_ctx.locales.common_save), 1)
                                ])
                            ])
                        ])
                    ])
                ]))
                : _createCommentVNode("", true);
        };
    }
});
